import React from "react";
import phoneImg from "../assets/images/phone_img.png";
import "../styles/Home.css";
import Navbar from "../components/NavBar";
import MedicalServices from "./MedicalServices";
import TestimonialsSection from "./TestimonialsSection";
import Register from "./Register";
import Footer from "./Footer";

export default function Home() {
  return (
    <div className="landing-page">
      <Navbar />
      {/* Hero Section - This is the landing page */}
      <section id="home" className="hero-section">
        <div className="hero-container">
          {/* Left Content */}
          <div className="hero-content">
            <h1 className="hero-title">
              Your Health Our
              <br />
              <span className="hero-highlight">
                Heartfelt
                <svg
                  className="curved-underline"
                  viewBox="0 0 200 20"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M10 15C50 5, 150 5, 190 15"
                    stroke="#2563eb"
                    strokeWidth="3"
                    fill="none"
                    strokeLinecap="round"
                  />
                </svg>
              </span>{" "}
              Mission
            </h1>

            <button className="btn-know-more">Know More</button>
          </div>
          {/* Right Content - Phone Mockup */}
          <div className="phone-container">
            <div className="phone-background"></div>
            <div className="phone-mockup">
              <img src={phoneImg} alt="MediGrow App" className="phone-image" />
            </div>
          </div>
        </div>
      </section>

      {/* Stats Section */}
      <section className="stats-section">
        <div className="stats-container">
          <div className="stat-item">
            <div className="stat-number">24/7</div>
            <div className="stat-label">Service</div>
          </div>
          <div className="stat-divider"></div>
          <div className="stat-item">
            <div className="stat-number">10+</div>
            <div className="stat-label">Blood Banks</div>
          </div>
          <div className="stat-divider"></div>
          <div className="stat-item">
            <div className="stat-number">100+</div>
            <div className="stat-label">Active Users</div>
          </div>
        </div>
      </section>

      {/* Services Section */}
      <div id="services">
        <MedicalServices />
      </div>

      <div>
        <TestimonialsSection />
      </div>

      <div>
        <Register />
      </div>

      <div>
        <Footer />
      </div>
    </div>
  );
}
